import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import applyResponsiveVdpStyles from '../../../../_shared/helpers/applyResponsiveVdpStyles';
import isOmpPlatform from '../../../../_shared/utils/isOmpPlatform';

const isOmp = isOmpPlatform();

/**
 * Variant Definitions
 */
const StyledUpcomingBidHistoryVariants = {
  mini: css`
    padding: 0;
  `,
  expanded: css`
    padding: 15px 15px 0;
  `
};

const StyledBidHistoryVariants = {
  upcoming: css`
    ${({ theme }) =>
      applyResponsiveVdpStyles(theme, {
        mini: StyledUpcomingBidHistoryVariants.mini,
        expanded: StyledUpcomingBidHistoryVariants.expanded
      })}
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  `,
  modal: css`
    ${isOmp &&
      css`
        border-top: 1px solid ${({ theme }) => theme.COLORS.NEUTRAL_110};
      `}
  `
};

const StyledBidHistoryPreviewVariants = {
  overview: css`
    display: none;
  `
};

const StyledBidHistoryPreview = styled.div`
  overflow-y: auto;
  padding: 0 18px;
  flex-direction: column-reverse;
  display: flex;
  height: 117px;

  &::-webkit-scrollbar {
    width: 3px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    width: 3px;
    background: ${({ theme }) => theme.COLORS.BASE_INVERTED};
    border-radius: 2px;
  }
`;

StyledBidHistoryPreview.Wrapper = styled.div`
  background: ${({ theme }) =>
    isOmp ? theme.COLORS.NEUTRAL : theme.COLORS.NEUTRAL_50};
  padding: 10px 10px 2px 0;
  height: 127px;
  ${({ theme, variant }) =>
    applyResponsiveVdpStyles(theme, {
      mini: StyledBidHistoryPreviewVariants[variant]
    })}
`;

StyledBidHistoryPreview.NoBidMessage = styled.div`
  color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
  font-size: 16px;
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  margin-top: 4px;
`;

StyledBidHistoryPreview.Shadow = styled.div`
  width: 100%;
  height: 10px;
  background: ${isOmp
    ? 'linear-gradient(rgb(249, 249, 249) 0%, rgba(0, 0, 0, 0.1) 100%) rgb(231, 231, 231)'
    : 'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.19) 100%)'};
  background-color: ${({ theme }) => theme.COLORS.NEUTRAL_50};
  ${({ theme, variant }) =>
    applyResponsiveVdpStyles(theme, {
      mini: StyledBidHistoryPreviewVariants[variant]
    })}
`;

export { StyledBidHistoryPreview };

const StyledPendingHistoryReportVariants = {
  mini: css`
    margin-right: 10px;
  `
};

/**
 * Styled Components
 */
const StyledBidHistory = styled.div`
  height: max-content;
  max-height: 209px;
  ${({ viewVariant }) => StyledBidHistoryVariants[viewVariant]};
  ${({ stateVariant }) =>
    stateVariant && StyledBidHistoryVariants[stateVariant]};
`;

StyledBidHistory.propTypes = {
  children: PropTypes.node,
  variant: PropTypes.oneOf(['upcoming', 'overview'])
};

StyledBidHistory.defaultProps = {
  children: undefined,
  variant: undefined
};

export { StyledBidHistory };

export const StyledLoadingState = styled.div`
  width: 100%;
  height: 152px;
`;

export const StyledPendingHistoryReport = styled.div`
  ${({ theme }) =>
    applyResponsiveVdpStyles(theme, {
      mini: StyledPendingHistoryReportVariants.mini
    })}
`;
